import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';

import { useLocation, useParams } from 'react-router-dom';

import { AddCandidateEducationInfo, DeleteCandidateEducation, GetCandidate } from '../services/httpServices';

import styled from '@emotion/styled';
import { Trash } from 'react-feather';
import ModalLayout from 'src/theme/Modal';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const CandidateEducationInfo = (props) => {
  const location = useLocation();
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [candidate, setCandidate] = useState({});

  const nameOfInstituteRef = useRef('');
  const fieldOfStudyRef = useRef('');
  const degreeRef = useRef('');
  const startDateRef = useRef('');
  const endDateRef = useRef('');
  const cityRef = useRef('');
  const provinceRef = useRef('');
  const countryRef = useRef('');

  const fetchCandidate = async (event) => {
    const candidate = await GetCandidate(id);

    setCandidate(candidate);
    setLoading(false);
  };
  useEffect(() => {
    fetchCandidate();
  }, [location]);

  const SaveCandidateEducation = async (event) => {
    setLoading(true);
    event.preventDefault();

    const payload = {
      nameOfInstitute: nameOfInstituteRef.current.value,
      fieldOfStudy: fieldOfStudyRef.current.value,
      degree: degreeRef.current.value,
      startDate: startDateRef.current.value,
      endDate: endDateRef.current.value,
      city: cityRef.current.value,
      province: provinceRef.current.value,
      country: countryRef.current.value,
    };

    let response = await AddCandidateEducationInfo(id, payload);

    if (response.status == 200) {
      props.setMessage('Candidate saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = candidate;
      clientSaved.mstCandidateEducations = response.data;
      setCandidate(clientSaved);
      setLoading(false);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
    }
  };

  const deleteCandidateEducation = async (rowId) => {
    setLoading(true);
    event.preventDefault();
    let response = await DeleteCandidateEducation(rowId);

    if (response.status == 200) {
      props.setMessage('Deleted successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let candidateSaved = candidate;
      candidateSaved.mstCandidateEducations = response.data;
      setCandidate(candidateSaved);
      setLoading(false);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
    }
  };
  return (
    <>
      {' '}
      <Box
        p={4}
        component={Paper}
        marginTop={4}
        boxShadow={3}
        sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Education Info
          </Typography>
        </Stack>
        <form onSubmit={SaveCandidateEducation}>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="20vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={1}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Name of Institute"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={nameOfInstituteRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Field of Study"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={fieldOfStudyRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Degree"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={degreeRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Start Date"
                        type="date"
                        required
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={startDateRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Till Date"
                        type="date"
                        required
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={endDateRef}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                      <TextField label="City" required variant="outlined" fullWidth size="small" inputRef={cityRef} />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Province"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={provinceRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Country"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={countryRef}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                      <Button type="submit" variant="contained">
                        Add
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <br></br>
                <br></br>
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Sr#</TableCell>
                        <TableCell>Name of Institute</TableCell>
                        <TableCell>Field of Study</TableCell>
                        <TableCell>Degree</TableCell>
                        <TableCell>Start Date</TableCell>
                        <TableCell>Till Date</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>Province</TableCell>
                        <TableCell>Country</TableCell>

                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {candidate?.mstCandidateEducations?.map((row, index) => (
                        <TableRow key={index + 1}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.nameOfInstitute}</TableCell>
                          <TableCell>{row.fieldOfStudy}</TableCell>
                          <TableCell>{row.degree}</TableCell>
                          <TableCell>{row.startDate?.split('T')[0]}</TableCell>
                          <TableCell>{row.endDate?.split('T')[0]}</TableCell>
                          <TableCell>{row.city}</TableCell>
                          <TableCell>{row.province}</TableCell>
                          <TableCell>{row.country}</TableCell>

                          <TableCell>
                            <ModalLayout
                              component={<Trash />}
                              description="Are You Sure you want to Delete?"
                              Hit={() => deleteCandidateEducation(row.id)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          )}
        </form>
      </Box>
    </>
  );
};

export default CandidateEducationInfo;
